import { StatusLabelProps } from './types';

import './style.scss';

export const StatusLabel = ({
  text = '',
  prefixIcon,
  status,
  dataTestId = ''
}: StatusLabelProps) => {
  return (
    <div className={`status-label ${status}`} data-testid={dataTestId}>
      {prefixIcon}
      <span className={'status-label__text'}>{text}</span>
    </div>
  );
};
